import { client } from "api";
import { Office } from "models/Office";

export type CreateOfficeRequest = { name: string, orderReviewerId: string | null };

export type CreateOfficeResponse = Office[];

export const createOffice = (data: CreateOfficeRequest) =>
  client.post<CreateOfficeResponse>(`/office`, data).then((res) => res.data);
